export default __webpack_public_path__ + "static/media/source-logo-canvas.3da7ed85.png";